export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14487.4b65e39f.jpg";